import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import _ from 'lodash';
import {confirmAlert} from "react-confirm-alert";
import AxisAdd from './../../elements/axis/widget/axis_add';
import AxisSearch from './../../elements/axis/widget/axis_search';

class ProigualdadAxis extends Component {
	render() {
		return (
			<AxisList {...this.props} />
		)
	}

	componentWillMount() {
		this.props.axisShow(this.props.axis.pages.current);
	}
}

export class AxisList extends Component {
	render() {
		let { axis } = this.props;

		let au = _.find(axis.permissions, (o) => {return o==='Update'});
		let ad = _.find(axis.permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{axis.isFetching ? <Loading /> :
					<table className={`inm-table`}>
						<thead>
						<tr>
							<th>ID</th>
							<th>Código</th>
							<th>Nombre</th>
						</tr>
						</thead>
						<tbody>
						{_.map(axis.list, (row, k) => {
							return (
								<tr key={k}>
									<td style={{width:'80px'}}>
										<div className="actions">
											{au ? <NavLink to={`/proigualdad/ejes/editar/${row.id}`}><i className="fa fa-edit"></i></NavLink>:''}
											{ad ? <button onClick={() => this._getConfirm(row.id, row.name)}><i className="fa fa-trash-o"></i></button>:''}
										</div>
										{row.id}
									</td>
									<td>{row.code}</td>
									<td><strong>{row.name}</strong></td>
								</tr>
							)
						})}
						</tbody>
					</table>}
				{axis.pages.total>20 &&
				<InmPagination key="axis-pages"
				               current={axis.pages.current}
				               total={axis.pages.total}
				               nextPage={this._handlePageChange}/>}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_handlePageChange(value) {
		const { axis } = this.props;
		this.props.axisShow(value, axis.filters);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el eje "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.axisDelete(id)
		})
	}
}

export default BaseLayout(ProigualdadAxis, {
	title:"Ejes Proigualdad",
	subnav: {
		icon: 'fa-flag-checkered',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Buscar',
				element: <AxisSearch />
			},
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <AxisAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/axis/index.jsx